export default "__VITE_ASSET__DoHqFutC__"